import qs from 'qs'
import request, { ResultHandler } from '@/core/utils/request'
const CustomerBaseUrl = '/business/customer'

export const queryCustomers = async params => {
  const result = await request({
    url: CustomerBaseUrl,
    method: 'GET',
    params: params,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
  return ResultHandler(result, 'Search customer failed!')?.records ?? []
}
